import dayjs from "dayjs";
import { createSelector } from "reselect";
import { getAllAccounts } from "./selectors";
import { formatCreditCardAccountsForDropdown } from "./utils";
import { AccountLOB, AccountStatus, } from "../types";
import { getCustomizations } from "../../customization/selectors";
/**
 * Returns all credit card accounts or an empty array.
 */
const getAllCreditCardAccounts = createSelector(getAllAccounts, (accounts) => { var _a; return (_a = accounts === null || accounts === void 0 ? void 0 : accounts.filter((account) => [AccountLOB.CC].includes(account.lob))) !== null && _a !== void 0 ? _a : []; });
/**
 * Returns all cards that do NOT meet the following criteria:
 * status of CLOSED, lastStatementDate older than 24 months ago, and zero balance
 */
const getAllValidCreditCardAccounts = createSelector(getAllCreditCardAccounts, (accounts) => {
    var _a;
    return (_a = accounts.filter((account) => {
        var _a, _b;
        const lastStatementDate = (_a = account.meta) === null || _a === void 0 ? void 0 : _a.lastStatementDate;
        const currentBalance = ((_b = account.balance) === null || _b === void 0 ? void 0 : _b.current) || 0;
        if (account.status === AccountStatus.CLOSED) {
            const twentyFourMonthsAgo = dayjs().subtract(2, "year");
            const isOlderThanTwoYears = dayjs(lastStatementDate).isBefore(twentyFourMonthsAgo);
            const hasBalance = currentBalance > 0;
            if (isOlderThanTwoYears && !hasBalance) {
                return false;
            }
        }
        return true;
    })) !== null && _a !== void 0 ? _a : [];
});
const getOpenCreditCardAccounts = createSelector(getAllCreditCardAccounts, (accounts) => {
    return accounts.filter(({ status }) => status === AccountStatus.NORMAL_STATUS);
});
const getCreditCardAccountsForDropdown = createSelector(getAllValidCreditCardAccounts, (_, customizations) => getCustomizations(customizations), (accounts, customizationOptions) => {
    return formatCreditCardAccountsForDropdown(accounts, customizationOptions);
});
/**
 * Get all credit card accounts
 *
 * Get all credit card accounts for dropdown, returns formatted credit card accounts with customization options
 *
 * Get open credit card accounts, returns all credit card accounts that have a status of NORMAL_STATUS
 *
 * Get valid credit card accounts, returns all credit card accounts that have not been open for more
 */
export default {
    getAll: getAllCreditCardAccounts,
    getAllForDropdown: getCreditCardAccountsForDropdown,
    getOpen: getOpenCreditCardAccounts,
    getValid: getAllValidCreditCardAccounts,
};
//# sourceMappingURL=creditCard.js.map